'use client';
import { useModalContext } from '@/context/modal';

const ModalManager = () => {
  const { modal } = useModalContext();

  if (modal) {
    return modal as JSX.Element;
  }

  return null;
};

export default ModalManager;
